import { Typography } from "@mui/material";
import { ContentTypography } from "./ServiceModal.styles";
import { FooterButton } from "../ServiceFunctionsModal.styles";
import React from "react";

export function SuccessfullyCopiedToClipboard({
    setOpen,
}: {
    setOpen: (value: boolean) => void;
}) {
    const modalTitle = <Typography>Erfolgreich kopiert!</Typography>;
    const modalContent = (
        <ContentTypography>
            Text erfolgreich in Zwischenablage kopiert.
        </ContentTypography>
    );
    const modalActions = (
        <FooterButton variant={"text"} onClick={() => setOpen(false)}>
            Schließen
        </FooterButton>
    );

    return { modalTitle, modalContent, modalActions, autoClosingModal: true };
}
